function fn_layout_header() {
    var $fn = $("#layout_header"),
        $header = $fn.find(".elm_header"),
        $header_bar = $fn.find(".elm_header_bar");

    if ($fn.length) {
        $fn.after('<nav id="layout_nav" class="ssm-nav"><div class="elm_head"></div><div class="elm_content"></div></nav>');

        $header.find(".col.mod--right").append($header_bar.find(".elm_lang").clone());

        var $layout_nav = $(document).find("#layout_nav"),
            $top_nav = $layout_nav.find(".elm_head"),
            $logo = $header.find(".elm_logo").clone(),
            $nav_title = $header.find(".elm_nav").data("title"),
            $nav = $header.find(".elm_nav ul").clone().addClass("elm_nav"),
            $actions_title = $header_bar.find(".elm_action").data("title"),
            $actions = $header_bar.find(".elm_action").clone(),
            $lang = $header_bar.find(".elm_lang").clone();

        $top_nav.append($logo);
        $layout_nav.find(".elm_content").append('<strong class="elm_title"><i>'+$nav_title+'</i></strong>');
        $layout_nav.find(".elm_content").append($nav);
        $layout_nav.find(".elm_content").append('<strong class="elm_title"><i>'+$actions_title+'</i></strong>');
        $layout_nav.find(".elm_content").append($actions);
        // $layout_nav.find(".elm_content").append($lang);

        var headroom = new Headroom($fn[0], {
            offset: $fn.height(),
            tolerance : {
                up : 5,
                down : 0
            },
            classes: {
                "initial" : "animated",
                "pinned": "slideDown",
                "unpinned": "slideUp",
                "top": "mod--header-top"
            },
            onTop : function() {
                if ($fn.hasClass("mod--header-fixed") && !$fn.hasClass("mod--header-lite")) {
                    $fn.addClass("mod--header-not-fixed");
                    setTimeout(function () {
                        $fn.removeClass("mod--header-fixed");
                        $fn.removeClass("mod--header-not-fixed");
                        $fn.addClass("mod--header-top");
                    },300);
                }
            },
            onNotTop : function() {
                $fn.removeClass("mod--header-top").removeClass("mod--header-not-fixed").addClass("mod--header-fixed");
            }
        });
        headroom.init();


        $('.ssm-nav').slideAndSwipe();
    }
}